import { defineFeature } from "../core/composition/define-feature.js";
import { loadChapters } from "../behaviors/dom/load-chapters.js";
//#region src/playback/features/chapters.ts
/** The behaviors the feature composes, in setup order. */
const behaviors = [loadChapters];
/** The config defaults the feature contributes. */
const defaultConfig = {};
/** The state values the feature seeds. */
const initialState = {};
/**
* Adds the source's Apple JSON chapters (`EXT-X-SESSION-DATA`, `com.apple.hls.chapters`) to the media element as a
* hidden `chapters` text track per language.
*/
const chaptersFeature = defineFeature({
	behaviors,
	defaultConfig,
	initialState
});
//#endregion
export { behaviors, chaptersFeature, defaultConfig, initialState };
